import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Box, Typography } from '@mui/material';

import type { CMS1500FormData } from '../ClaimCMS1500Form';
import { ClaimTextField } from '../fields';

export const Box14_DateOfCurrent: React.FC = () => {
  const { control } = useFormContext<CMS1500FormData>();
  return (
    <>
      <Typography variant="caption">
        14. DATE OF CURRENT ILLNESS/INJURY/PREGNANCY (LMP)
      </Typography>
      <Box display="flex" gap={1}>
        <Controller
          name="currentIllnessDate"
          control={control}
          render={({ field, fieldState }) => (
            <ClaimTextField
              field={field}
              fieldState={fieldState}
              type="date"
              size="small"
              fullWidth
            />
          )}
        />
        <Controller
          name="currentIllnessQualifier"
          control={control}
          render={({ field, fieldState }) => (
            <ClaimTextField
              field={field}
              fieldState={fieldState}
              size="small"
              placeholder="Qual"
              disabled
              sx={{ width: '80px' }}
            />
          )}
        />
      </Box>
    </>
  );
};